module.exports = __webpack_public_path__ + "img/shenfenzhengzhengmian.2281906a.png";